package horcrux.frontend.common.views.auth

import horcrux.common.utils.EnumCompanion
import horcrux.common.utils.StringEnum
import horcrux.frontend.common.views.components.input.selectors.ButtonSelectorProp
import horcrux.frontend.common.views.components.input.selectors.buttonSelector
import react.FC

enum class AuthEnum(override val stringValue: String) : StringEnum {
    SIGN_UP("Sign Up"), SIGN_IN("Sign In");

    companion object : EnumCompanion<AuthEnum> {
        override val valuesList: List<AuthEnum> = AuthEnum.values().toList()
        val Selector: FC<ButtonSelectorProp<AuthEnum>> = this.buttonSelector()
    }
}
